var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blast.reviewsGiven.length)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.blast.reviewsGiven.length)+" reviews you've given to others:")]),_vm._v(" "),_c('peer-reviews',{attrs:{"reviews":_vm.blast.reviewsGiven,"display":"given"}})],1):_c('div',[_vm._v("\n  You have not given any peer reviews yet.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da32654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-reviews-given.vue
// module id = null
// module chunks = 